export default __webpack_public_path__ + "static/media/vUsdt.63b81cf4.svg";